import { SimpleMenu } from "@components";
import { useTranslation } from "react-i18next";

const MyMenu = function ({ active }) {
  const { t } = useTranslation();

  return (
    <SimpleMenu
      title={t("tata_kelola_perusahaan")}
      active={active}
      menu={[
        {
          text: t("tentang_tata_kelola_perusahaan"),
          link: "/corporate-governance/about",
        },
        {
          text: t("piagam"),
          link: "/corporate-governance/piagam",
        },
        {
          text: t("pedoman"),
          link: "/corporate-governance/guidelines",
        },
        {
          text: t("laporan_tata_kelola"),
          link: "/corporate-governance/report",
        },
        {
          text: t("kode_etik"),
          link: "/corporate-governance/code-of-ethics",
        },
        {
          text: t("whistleblowing_system"),
          link: "/corporate-governance/whistleblowing-system",
        },
        {
          text: t("privacy_notice"),
          link: "/corporate-governance/privacy-notice",
        },
      ]}
    />
  );
};
export default MyMenu;
